import React, { useCallback } from 'react';

import Checkbox from '@search/vtbeco-ui/src/components/controls/NewCheckbox';
import { HouseCategory } from '@search/filter-enums/enums';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { HouseCategoryFilter } from '../../../../models/Filter';
import { IFilterAvailableProps } from '../../../new_filter/Filter2';
import { CheckboxGroup2, ICheckboxGroupModificationProps } from '../../../common/CheckboxGroup2';

const selectOptions = [ {
    value: HouseCategory.STANDALONE,
    label: 'Отдельный дом'
}, {
    value: HouseCategory.PART_OF_HOUSE,
    label: 'Часть дома'
}, {
    value: HouseCategory.TOWNHOUSE,
    label: 'Таунхаус'
}, {
    value: HouseCategory.DUPLEX,
    label: 'Дуплекс'
} ];

interface IMobileHouseCategoryFilterViewProps extends IFilterAvailableProps, ICheckboxGroupModificationProps {
    filter: HouseCategoryFilter;
    handleChange: (filter: HouseCategoryFilter) => void;
    isMobile?: boolean;
}

export const MobileHouseCategoryFilterView: React.FC<IMobileHouseCategoryFilterViewProps> = ({
    filter,
    handleChange,
    withoutTitle,
    isMobile,
    classNameGroup
}) => {
    const onChange = useCallback(items => {
        handleChange(new HouseCategoryFilter(items));
    }, [ handleChange ]);

    return (
        <MobileFilter2 desktopTitleGap={! isMobile} filterTitle={withoutTitle ? undefined : 'Тип дома'}>
            <CheckboxGroup2
                mode='check'
                onChange={onChange}
                name='filter-house'
                value={filter.categories}
                withoutGrid
                classNameGroup={classNameGroup}
            >
                {selectOptions.map(({ value, label }) => (
                    <Checkbox
                        type='button'
                        view='primary'
                        tone='secondary'
                        key={value}
                        value={value}
                    >
                        {label}
                    </Checkbox>
                ))}
            </CheckboxGroup2>
        </MobileFilter2>
    );
};
